import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@mui/material";
import HPButton from "@/components/common/Button";
import HPInput from "@/components/common/Input";

interface UnavailableConfirmDialogProps {
  brandLabel: string | undefined;
  open: boolean;
  reason: string;
  onReasonChange: (reason: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
}

/** Shared "Mark Unavailable" confirmation — used by both a row's own Brand
 *  Mappings and a New Base Metric's compact unresolved-mapping list. */
const UnavailableConfirmDialog: React.FC<UnavailableConfirmDialogProps> = ({
  brandLabel,
  open,
  reason,
  onReasonChange,
  onCancel,
  onConfirm,
}) => (
  <Dialog open={open} onClose={onCancel}>
    <DialogTitle>Mark {brandLabel} Unavailable?</DialogTitle>
    <DialogContent>
      <Typography variant="body2" sx={{ mb: 2 }}>
        This intersection will show as Unavailable instead of a value, and
        counts as valid for Save. You can restore it later.
      </Typography>
      <HPInput
        label="Reason (optional)"
        value={reason}
        onChange={(e) => onReasonChange(e.target.value)}
        placeholder="e.g. Not tracked for this brand"
      />
    </DialogContent>
    <DialogActions>
      <HPButton variant="text" onClick={onCancel}>
        Cancel
      </HPButton>
      <HPButton variant="contained" onClick={onConfirm}>
        Mark Unavailable
      </HPButton>
    </DialogActions>
  </Dialog>
);

export default UnavailableConfirmDialog;
